import React from 'react';
import { motion } from 'framer-motion';
interface TitleHookSlideProps {
  content: {
    headline: string;
    subHeadline: string;
  };
}
export function TitleHookSlide({
  content
}: TitleHookSlideProps) {
  return <div className="bg-[#017C6D] rounded-2xl p-16 text-center min-h-[600px] flex flex-col items-center justify-center relative overflow-hidden" data-id="element-233">
      {/* Background Accent */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#0FB07D]" data-id="element-234" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="mb-12" data-id="element-235">
        <img src="https://cdn.magicpatterns.com/uploads/8NCm2XruQu52NQS63PYsNZ/VA-Logo_(1).png" alt="Viridia Analytics" className="h-28 w-auto" data-id="element-236" />
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.2
    }} className="text-5xl md:text-6xl font-bold text-[#F5F5F5] mb-8 leading-tight max-w-4xl" data-id="element-237">
        {content.headline}
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="text-2xl text-[#F5F5F5]/90 max-w-3xl leading-relaxed font-medium" data-id="element-238">
        {content.subHeadline}
      </motion.p>
    </div>;
}
export default TitleHookSlide;